import React, { useContext } from 'react';
import { SignaturePad, lbl, inp } from './ContractKit';

const ROContext = React.createContext(false);
const HideSigContext = React.createContext(false);
const Sig = (props) => { const hide = useContext(HideSigContext); return hide ? null : <SignaturePad {...props} />; };

const ACK_ITEMS = [
  'Home Improvement Contract', 'Waiver of Right to Cancel', 'Disclosure re: CGL Insurance',
  'Information about CSLB', 'Notice of Arbitration', 'Arbitration of Disputes',
  'Three-Day Right to Cancel', 'Notice of Cancellation (in duplicate)', 'Mechanic Lien Warning',
];

const Row = ({ children }) => (
  <div className="cf-grid2" style={{ gap: 12, marginBottom: 12 }}>{children}</div>
);
const Field = ({ label, value, onChange, type = 'text' }) => {
  const ro = useContext(ROContext);
  return (
    <div>
      <label style={lbl}>{label}</label>
      {ro
        ? <div style={{ ...inp, background: '#f3f4f5', color: '#333', minHeight: 38, display: 'flex', alignItems: 'center', cursor: 'default' }}>{value || <span style={{ color: '#bbb' }}>—</span>}</div>
        : <input type={type} style={inp} value={value || ''} onChange={(e) => onChange(e.target.value)} />}
    </div>
  );
};

const RoCheckbox = (props) => { const ro = useContext(ROContext); return <input type="checkbox" {...props} disabled={ro} onChange={ro ? undefined : props.onChange} />; };
const RoTextarea = ({ value, onChange }) => { const ro = useContext(ROContext); return ro
  ? <div style={{ ...inp, minHeight: 120, background: '#f3f4f5', color: '#333', whiteSpace: 'pre-wrap' }}>{value || <span style={{ color: '#bbb' }}>—</span>}</div>
  : <textarea style={{ ...inp, minHeight: 120 }} value={value} onChange={onChange} />; };

const COATING_ITEMS = [
  'Waterblast exterior walls and eaves of home where necessary.',
  'Patch and repair cracks and breaks on stucco where necessary.',
  'Mask all doors and windows where necessary.',
  'Trench approximately 3" to 6" where soil meets foundation.',
];
const TRIM_ITEMS = [
  'Apply COOL LIFE / COTE to stucco surfaces.',
  'Apply COOL LIFE / COTE to wood surfaces.',
];
const OTHER_WORK = [
  'Doors', 'Door Trim', 'Windows', 'Window Trim', 'Security Bars', 'Security Door',
  'Garage Door', 'Garage Door Trim', 'Gates', 'Railing Metal / Wood', 'Block Wall',
  'Awning', 'Vents Sub/Attic', 'Shutters', 'Wood Replacement', 'Fences',
  'Patio Overhang', 'Post/Beam', 'Wood Siding',
];

// Renders the field set for a given contract type. `f` = form state, `set(key,val)` updater.
// When readOnly, every field is locked and only the signature pad stays editable.
export default function ContractFields({ type, f, set, readOnly = false, hideSignature = false }) {
  const ro = readOnly;
  const setOther = (item, key, val) => set('other', { ...(f.other || {}), [item]: { ...((f.other || {})[item] || {}), [key]: val } });
  return (
    <ROContext.Provider value={readOnly}>
    <HideSigContext.Provider value={hideSignature}>
    <>

      <Row>
        <Field label="Customer's Name" value={f.customer_name} onChange={(v) => set('customer_name', v)} />
        <Field label="Address" value={f.address} onChange={(v) => set('address', v)} />
      </Row>

      {type === 'coating' && (
        <>
          <Field label="Attached to contract authorization number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />

          <div className="cf-grid2" style={{ gap: 18, marginTop: 14 }}>
            {/* I. Exterior Coating */}
            <div>
              <label style={lbl}>I. Exterior Coating</label>
              {COATING_ITEMS.map((t, i) => (
                <label key={i} style={{ fontSize: 12.5, display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 6, cursor: 'pointer' }}>
                  <RoCheckbox checked={!!(f.coating || {})[i]} onChange={() => set('coating', { ...(f.coating || {}), [i]: !(f.coating || {})[i] })} />
                  <span>{i + 1}. {t}</span>
                </label>
              ))}
              <label style={{ fontSize: 12.5, display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6, cursor: 'pointer' }}>
                <RoCheckbox checked={!!f.primer} onChange={() => set('primer', !f.primer)} />
                <span>5. Apply COOL LIFE PRIMER</span>
              </label>
              {f.primer && (
                <div style={{ display: 'flex', gap: 14, marginLeft: 26, marginBottom: 6 }}>
                  {['TEXTURED', 'SMOOTH'].map(t => (
                    <label key={t} style={{ fontSize: 12, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                      <RoCheckbox checked={f.primerTexture === t} onChange={() => set('primerTexture', f.primerTexture === t ? '' : t)} /> {t}
                    </label>
                  ))}
                </div>
              )}
            </div>
            {/* II. Trim */}
            <div>
              <label style={lbl}>II. Trim — Fascia / Eaves / Wood Siding</label>
              {TRIM_ITEMS.map((t, i) => (
                <label key={i} style={{ fontSize: 12.5, display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 6, cursor: 'pointer' }}>
                  <RoCheckbox checked={!!(f.trim || {})[i]} onChange={() => set('trim', { ...(f.trim || {}), [i]: !(f.trim || {})[i] })} />
                  <span>{i + 6}. {t}</span>
                </label>
              ))}
              <Field label="8. Color of COOL LIFE System" value={f.coolLifeSystemColor} onChange={(v) => set('coolLifeSystemColor', v)} />
              <Field label="9. Color of COOL LIFE" value={f.coolLifeColor} onChange={(v) => set('coolLifeColor', v)} />
              <div style={{ display: 'flex', gap: 16, marginTop: 6 }}>
                <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                  <RoCheckbox checked={!!f.house} onChange={() => set('house', !f.house)} /> 10. House
                </label>
                <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
                  <RoCheckbox checked={!!f.garage} onChange={() => set('garage', !f.garage)} /> Garage
                </label>
              </div>
            </div>
          </div>

          {/* III. Other Work — YES/NO + Quantity */}
          <label style={{ ...lbl, marginTop: 16 }}>III. Other Work To Be Done (mark YES to include in scope &amp; price)</label>
          <div className="cf-ow">
            {OTHER_WORK.map((item, i) => {
              const o = (f.other || {})[item] || {};
              return (
                <div key={item} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12.5 }}>
                  <span style={{ width: 118, flexShrink: 0 }}>{i + 1}. {item}</span>
                  {['YES', 'NO'].map(yn => (
                    <label key={yn} style={{ display: 'flex', gap: 3, alignItems: 'center', cursor: 'pointer' }}>
                      <RoCheckbox checked={o.yn === yn} onChange={() => setOther(item, 'yn', o.yn === yn ? '' : yn)} /> {yn}
                    </label>
                  ))}
                  <input disabled={ro} placeholder="Qty" value={o.qty || ''} onChange={(e) => setOther(item, 'qty', e.target.value)}
                    style={{ width: 48, fontSize: 12, padding: '3px 5px', border: '1px solid #ccc', borderRadius: 5, background: ro ? '#f3f4f5' : '#fff' }} />
                </div>
              );
            })}
          </div>

          <div style={{ marginTop: 14 }}>
            <Field label="Special Instructions" value={f.special} onChange={(v) => set('special', v)} />
            <Field label="Work NOT to be done" value={f.workNot} onChange={(v) => set('workNot', v)} />
            <label style={{ fontSize: 12.5, display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, cursor: 'pointer' }}>
              <RoCheckbox checked={!!f.noAdditional} onChange={() => set('noAdditional', !f.noAdditional)} />
              No additional work to be done by contractor unless specified in writing.
            </label>
          </div>

          <Row>
            <div><Sig label="Buyer's Signature" onChange={(v) => set('buyerSig', v)} /><Field label="Date" type="date" value={f.buyerDate} onChange={(v) => set('buyerDate', v)} /></div>
            <div><Sig label="Representative Signature" onChange={(v) => set('repSig', v)} /></div>
          </Row>
        </>
      )}

      {type === 'windows' && (() => {
        const rows = Array.isArray(f.windows) && f.windows.length ? f.windows : [{}, {}, {}];
        const setRow = (i, k, v) => {
          const next = rows.map((r, j) => (j === i ? { ...r, [k]: v } : r));
          set('windows', next);
        };
        const addRow = () => set('windows', [...rows, {}]);
        const cell = { padding: '5px 6px', border: '1px solid #e2e4e8', fontSize: 12.5, width: '100%', borderRadius: 5 };
        const COLS = [
          ['location', 'Location', 120], ['style', 'Style', 62], ['width', 'W', 48], ['height', 'H', 48],
          ['glass', 'Glass', 54], ['grid', 'Grid', 54], ['frame', 'Frame', 58], ['temp', 'Temp', 52],
          ['m_width', 'M.W', 52], ['m_height', 'M.H', 52], ['extras', 'Extras', 100],
        ];
        return (
          <>
            <Field label="Attached to contract authorization number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />

            <div style={{ marginTop: 16, fontWeight: 700, fontSize: 13, color: '#0d1f3b' }}>Windows to be installed</div>
            <div style={{ fontSize: 11, color: '#7c818a', margin: '4px 0 9px', lineHeight: 1.5 }}>
              STYLE XO · SH · DH · BAY · BOW · XOX · CSMT &nbsp;|&nbsp; GLASS (C) Clear (G) Grey (B) Bronze (O) Obscure (L) Low E<br />
              GRID (F) 5/8" Flat (S) 5/8" Sculp (E) 1" Euro (N) None &nbsp;|&nbsp; FRAME (S) Standard (N) Nail-On (B) Brick (CT) Cut/Tuck (BLK) Block
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ borderCollapse: 'collapse', minWidth: 700 }}>
                <thead>
                  <tr>{COLS.map(([k, label, w]) => (
                    <th key={k} style={{ fontSize: 10.5, textAlign: 'left', color: '#7c818a', padding: '0 6px 5px', minWidth: w }}>{label}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {rows.map((r, i) => (
                    <tr key={i}>
                      {COLS.map(([k]) => (
                        <td key={k} style={{ padding: '0 3px 5px' }}>
                          <input style={cell} value={r[k] || ''} onChange={(e) => setRow(i, k, e.target.value)} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button type="button" onClick={addRow}
              style={{ marginTop: 8, fontSize: 12.5, fontWeight: 700, background: 'none', border: '1px dashed #b9bec6',
                borderRadius: 8, padding: '7px 14px', cursor: 'pointer', color: '#0d1f3b' }}>＋ Add a window</button>

            <div style={{ marginTop: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#0d1f3b', marginBottom: 6 }}>Special instructions / notes</div>
              <RoTextarea value={f.notes} onChange={(v) => set('notes', v)} />
            </div>

            <Row>
              <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
                <RoCheckbox checked={!!f.color_white} onChange={(e) => set('color_white', e.target.checked)} /> Color: White
              </label>
              <Field label="Other color" value={f.color_other_text} onChange={(v) => { set('color_other_text', v); set('color_other', !!v); }} />
            </Row>
            <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
              <RoCheckbox checked={f.disposal !== false} onChange={(e) => set('disposal', e.target.checked)} /> Disposal of all job related debris
            </label>

            <Row>
              <Field label="Production start date" value={f.start_date} onChange={(v) => set('start_date', v)} />
              <Field label="Turn-around time" value={f.turnaround} onChange={(v) => set('turnaround', v)} />
            </Row>
            <Field label="Days to complete" value={f.days_complete} onChange={(v) => set('days_complete', v)} />
          </>
        );
      })()}

      {type === 'colors' && (
        <>
          <Field label="Attached to contract authorization number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />
          <div style={{ marginTop: 14, fontWeight: 700, fontSize: 13, color: '#0d1f3b' }}>Colors chosen</div>
          <Row>
            <Field label="Stucco(s)" value={f.color_stucco} onChange={(v) => set('color_stucco', v)} />
            <Field label="Wood walls" value={f.color_wood} onChange={(v) => set('color_wood', v)} />
          </Row>
          <Row>
            <Field label="Eaves" value={f.color_eaves} onChange={(v) => set('color_eaves', v)} />
            <Field label="Fascia" value={f.color_fascia} onChange={(v) => set('color_fascia', v)} />
          </Row>
          <div style={{ background: '#FFF8E6', border: '1px solid #F0D99A', borderRadius: 10, padding: '11px 14px',
            fontSize: 12.5, color: '#6B4E10', marginTop: 12, lineHeight: 1.5 }}>
            The customer is agreeing to a <b>25% charge if colors change after three days</b>, and that any change must be in writing.
          </div>
          <Row>
            <Field label="Project manager" value={f.project_manager} onChange={(v) => set('project_manager', v)} />
            <Field label="Project manager phone" value={f.pm_phone} onChange={(v) => set('pm_phone', v)} />
          </Row>
        </>
      )}

      {type === 'roofing' && (() => {
        const rd = f.roofing || {};
        const setR = (k, v) => set('roofing', { ...rd, [k]: v });
        const YN = ({ n }) => (
          <span style={{ display: 'flex', gap: 8, flexShrink: 0, width: 92 }}>
            {['YES', 'NO'].map(yn => (
              <label key={yn} style={{ display: 'flex', gap: 3, alignItems: 'center', cursor: 'pointer', fontSize: 12 }}>
                <RoCheckbox checked={rd['yn' + n] === yn} onChange={() => setR('yn' + n, rd['yn' + n] === yn ? '' : yn)} /> {yn}
              </label>
            ))}
          </span>
        );
        const Pick = ({ k, opts }) => (
          <span style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {opts.map(op => (
              <label key={op} style={{ display: 'flex', gap: 3, alignItems: 'center', cursor: 'pointer', fontSize: 12 }}>
                <RoCheckbox checked={rd[k] === op} onChange={() => setR(k, rd[k] === op ? '' : op)} /> {op}
              </label>
            ))}
          </span>
        );
        const Mini = ({ k, ph, w = 70 }) => (
          <input disabled={readOnly} placeholder={ph} value={rd[k] || ''} onChange={(e) => setR(k, e.target.value)}
            style={{ width: w, fontSize: 12, padding: '3px 6px', border: '1px solid #ccc', borderRadius: 5, background: readOnly ? '#f3f4f5' : '#fff' }} />
        );
        const RowItem = ({ n, label, children }) => (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, flexWrap: 'wrap', padding: '5px 0', borderBottom: '1px solid #f0f1f2' }}>
            <YN n={n} />
            <span>{n}. {label}</span>
            {children}
          </div>
        );
        return (
        <>
          <Field label="Attached to contract authorization number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />

          <label style={{ ...lbl, marginTop: 14 }}>Tear Off</label>
          <div style={{ display: 'flex', gap: 18, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
            <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
              <RoCheckbox checked={!!rd.tear_house} onChange={() => setR('tear_house', !rd.tear_house)} /> House
            </label>
            <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
              <RoCheckbox checked={!!rd.tear_garage} onChange={() => setR('tear_garage', !rd.tear_garage)} /> Garage
            </label>
            {rd.tear_garage && <Pick k="garage_type" opts={['ATTACHED', 'DETACHED']} />}
            <label style={{ fontSize: 12.5, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
              <RoCheckbox checked={!!rd.tear_flat} onChange={() => setR('tear_flat', !rd.tear_flat)} /> Flat
            </label>
          </div>

          <label style={lbl}>Descriptions of Work To Be Done (mark YES to include in scope &amp; price)</label>
          <div style={{ marginBottom: 8 }}>
            <RowItem n={1} label="Tear off & haul away existing roofing material" />
            <RowItem n={2} label="Pull all nails" />
            <RowItem n={3} label="Number of layers"><Mini k="layers" ph="#" w={44} /><Pick k="layers_type" opts={['Comp', 'Rock', 'Wood', 'Tile']} /></RowItem>
            <RowItem n={4} label="Inspect roof deck" />
            <RowItem n={5} label="Replace linear ft. of starter board/fascia"><Mini k="starter_ft" ph="lin. ft." w={60} /></RowItem>
            <RowItem n={6} label="Replace linear ft. of roof deck"><Mini k="deck_ft" ph="lin. ft." w={60} /></RowItem>
            <RowItem n={7} label="Satellite/Antenna"><Pick k="satellite" opts={['Remove', 'Replace', 'Comdeck']} /></RowItem>
            <RowItem n={8} label="Install underlayment"><Pick k="underlayment" opts={['15# ASTM', 'Deck Defense', 'Weather Lock']} /></RowItem>
            <RowItem n={9} label="Install starter strip around perimeter" />
            <RowItem n={10} label="Install edge metal to match roof color">
              <Pick k="edge_color" opts={['Brown', 'Black', 'White', 'Other']} />
              {rd.edge_color === 'Other' && <Mini k="edge_color_other" ph="color" w={90} />}
            </RowItem>
            <RowItem n={11} label="Type of edge metal"><Pick k="edge_size" opts={['1 1/2\"', '2\"', '3\"']} /></RowItem>
            <RowItem n={12} label="Replace all roof jacks & caps" />
            <RowItem n={13} label={'Install 1/2\" OSB sheeting'} />
            <RowItem n={14} label="Install roofing material">
              <Mini k="material_type" ph="Type" w={150} /><Mini k="material_year" ph="Year" w={54} /><Mini k="material_color" ph="Color" w={100} />
            </RowItem>
            <RowItem n={15} label="Install Ridgevents (over 3/12 pitch only / No open beam or vaulted)" />
            <RowItem n={16} label="Install high profile ridge trim">
              <Mini k="trim_type" ph="Type" w={120} /><Mini k="trim_color" ph="Color" w={100} />
            </RowItem>
            <RowItem n={17} label="Paint all roof jacks & caps"><Mini k="jack_color" ph="Color" w={100} /></RowItem>
            <RowItem n={18} label="Clean up & haul away all job-related debris (Attic will not be touched)" />
          </div>

          <div style={{ background: '#f7f7f8', border: '1px solid #e2e4e6', borderRadius: 8, padding: '10px 12px', fontSize: 11.5, color: '#555', marginBottom: 12 }}>
            <b>NOTICE:</b> Wood replacement beyond the agreed footage is billed at $16/lin. ft.
            Contractor is not responsible for existing gutters — remove/replace at $5/lin. ft. or new gutters @ $14/lin. ft.
            Final payment is due upon completion and is not withheld pending city inspection.
            <span style={{ display: 'block', marginTop: 4 }}>The customer initials this notice on the signed document.</span>
          </div>

          <div style={{ marginTop: 6 }}>
            <Field label="Special Instructions / Notes" value={f.special} onChange={(v) => set('special', v)} />
          </div>

          <Row>
            <div><Sig label="Buyer's Signature" onChange={(v) => set('buyerSig', v)} /><Field label="Date" type="date" value={f.buyerDate} onChange={(v) => set('buyerDate', v)} /></div>
            <div><Sig label="Representative Signature" onChange={(v) => set('repSig', v)} /></div>
          </Row>
        </>
        );
      })()}

      {type === 'lien' && (
        <>
          <Row>
            <Field label="Buyer's Initials (arbitration)" value={f.buyer_initials} onChange={(v) => set('buyer_initials', v)} />
            <Field label="Contractor's Initials" value={f.contractor_initials} onChange={(v) => set('contractor_initials', v)} />
          </Row>
          <label style={lbl}>Customer Acknowledgment (check what was received)</label>
          <div className="cf-grid2" style={{ gap: 6, marginBottom: 14 }}>
            {ACK_ITEMS.map((a, i) => (
              <label key={i} style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
                <RoCheckbox checked={!!(f.ack || {})[i]} onChange={() => set('ack', { ...(f.ack || {}), [i]: !(f.ack || {})[i] })} /> {a}
              </label>
            ))}
          </div>
          <Row>
            <Field label="Date" type="date" value={f.buyerDate} onChange={(v) => set('buyerDate', v)} />
            <div><Sig label="Buyer's Signature" onChange={(v) => set('buyerSig', v)} /></div>
          </Row>
        </>
      )}

      {type === 'change-order' && (
        <>
          <Field label="Attached to contract authorization number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />
          <div style={{ marginTop: 12 }}>
            <label style={lbl}>Changes to Original Contract (one per line)</label>
            <RoTextarea value={f.changes || ''} onChange={(e) => set('changes', e.target.value)} />
          </div>
          <label style={{ ...lbl, marginTop: 12 }}>Finance Summary</label>
          <Row cols="1fr 1fr">
            <Field label="Amount of Original Contract ($)" value={f.amt_original} onChange={(v) => set('amt_original', v)} />
            <Field label="Change Amount [+/-] ($)" value={f.amt_change} onChange={(v) => set('amt_change', v)} />
            <Field label="New Contract Amount ($)" value={f.amt_new} onChange={(v) => set('amt_new', v)} />
            <Field label="Deposit ($)" value={f.amt_deposit} onChange={(v) => set('amt_deposit', v)} />
            <Field label="Remaining Balance ($)" value={f.amt_balance} onChange={(v) => set('amt_balance', v)} />
          </Row>
          <Field label="Authorized acceptor name" value={f.accept_name} onChange={(v) => set('accept_name', v)} />
          <Row>
            <div><SignaturePad label="Customer Signature" onChange={(v) => set('custSig', v)} /><Field label="Date" type="date" value={f.custDate} onChange={(v) => set('custDate', v)} /></div>
            <div><Sig label="Representative Signature" onChange={(v) => set('repSig', v)} /><Field label="Date" type="date" value={f.repDate} onChange={(v) => set('repDate', v)} /></div>
          </Row>
        </>
      )}

      {type === 'hia' && (
        <>
          <Row>
            <Field label="Authorization Number" value={f.auth_number} onChange={(v) => set('auth_number', v)} />
            <Field label="Page Number" value={f.page_number} onChange={(v) => set('page_number', v)} />
          </Row>
          <Row>
            <Field label="Buyer's Name" value={f.buyer_name} onChange={(v) => set('buyer_name', v)} />
            <Field label="Agreement Date" type="date" value={f.agreement_date} onChange={(v) => set('agreement_date', v)} />
          </Row>
          <Field label="Property Address" value={f.property_address} onChange={(v) => set('property_address', v)} />
          <Row>
            <Field label="Email" value={f.email} onChange={(v) => set('email', v)} />
            <Field label="Home Tel" value={f.home_tel} onChange={(v) => set('home_tel', v)} />
          </Row>
          <Row>
            <Field label="Agreement Price ($)" value={f.agreement_price} onChange={(v) => set('agreement_price', v)} />
            <Field label="Down Payment ($)" value={f.down_payment} onChange={(v) => set('down_payment', v)} />
          </Row>
          <label style={lbl}>Payment Schedule</label>
          <Row cols="1fr 1fr 1fr">
            <Field label="Upon Re-Measurement ($)" value={f.pay_remeasure} onChange={(v) => set('pay_remeasure', v)} />
            <Field label="Upon Initial Start ($)" value={f.pay_start} onChange={(v) => set('pay_start', v)} />
            <Field label="Upon Final Install ($)" value={f.pay_final} onChange={(v) => set('pay_final', v)} />
          </Row>
          <Row>
            <Field label="Approx. Start Date" type="date" value={f.start_date} onChange={(v) => set('start_date', v)} />
            <Field label="Approx. Completion Date" type="date" value={f.completion_date} onChange={(v) => set('completion_date', v)} />
          </Row>
          <Row>
            <div><Sig label="Buyer's Signature" onChange={(v) => set('buyerSig', v)} /><Field label="Date" type="date" value={f.buyerDate} onChange={(v) => set('buyerDate', v)} /></div>
            <div><SignaturePad label="Amanda's Home Improvement Signature" onChange={(v) => set('repSig', v)} /></div>
          </Row>
        </>
      )}

      {type === 'cancel' && (
        <>
          <Row>
            <Field label="Acknowledging name" value={f.ack_name} onChange={(v) => set('ack_name', v)} />
            <Field label="Date provided this document" type="date" value={f.ack_date} onChange={(v) => set('ack_date', v)} />
          </Row>
          <div style={{ marginBottom: 14 }}><Sig label="Buyer's Signature" onChange={(v) => set('buyerSig', v)} /></div>
          <div style={{ borderTop: '1px solid #ddd', paddingTop: 12, marginTop: 8 }}>
            <label style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer', marginBottom: 10 }}>
              <RoCheckbox checked={!!f.waive} onChange={() => set('waive', !f.waive)} />
              <strong>WAIVER:</strong> I hereby waive my three-day right to cancel (emergency).
            </label>
            {f.waive && (
              <Row>
                <Field label="Waiver Date" type="date" value={f.waiveDate} onChange={(v) => set('waiveDate', v)} />
                <div><SignaturePad label="Buyer's Signature (waiver)" onChange={(v) => set('waiveSig', v)} /></div>
              </Row>
            )}
          </div>
        </>
      )}
    </>
    </HideSigContext.Provider>
    </ROContext.Provider>
  );
}
